import { SvgIcon } from "@mui/material";
import { styled } from "@mui/system";

const IconLogo = () => {
  const Logo = styled("p")({});
  return (
    <>
      <svg
        version="1.1"
        id="Layer_1"
        width="102"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 5000 2992.52"
        style={{ enableBackground: "new 0 0 5000 2992.52" }}
        xmlSpace="preserve"
      >
        <g>
          <path
            d="M4584.19,1461.25c0-159.99,0-318.87,0-477.51c7.95-2.51,58.38-2.93,68.92-0.81c2.04,7.93,2.22,1017.06,0.05,1026.67
      c-22.38,0-44.9,0-68.82,0c-0.61-17.6-0.18-35.12-0.26-52.62c-0.08-17.66-0.02-35.33-0.02-52.99c0-17.66,0-35.33,0-52.99
      c0-17.66,0-35.33,0-52.99c0-17.33,0-34.66,0-51.99c0-17.66,0-35.33,0-52.99c0-17.66,0-35.33,0-52.99c0-17.66,0-35.33,0-52.99
      c0-17.63,0-35.26,0-52.68c-7.77-2.26-554.71-3.24-573.93-1.23c-0.3,0.27-0.56,0.48-0.78,0.72c-0.22,0.24-0.52,0.48-0.6,0.77
      c-0.19,0.63-0.31,1.3-0.38,1.96c-0.07,0.66-0.08,1.33-0.08,2c-0.12,156.3-0.25,312.6-0.38,468.9c0,0.32-0.18,0.64-0.28,0.96
      c-6.74,2.16-54.47,2.77-68.2,0.87c-2.06-7.32-2.46-1015.51-0.12-1027.53c22.19-0.11,44.69-0.13,68.51,0.05
      c0.9,12.71,0.34,24.92,0.44,37.09c0.1,12.33,0.02,24.66,0.02,36.99s0,24.66,0,36.99c0,12,0,24,0,35.99c0,12.33,0,24.66,0,36.99
      s0,24.66,0,36.99s0,24.66,0,36.99s0,24.66,0,36.99c-0.01,12.33-0.03,24.66-0.03,36.99c-0.01,12,0,24,0,36c0,12.33,0,24.66,0,36.99
      s0,24.66,0,36.99c0,12.24,0,24.48,0,37.41C4200.46,1461.25,4391.58,1461.25,4584.19,1461.25z"
          />
          <path
            d="M1037.04,1532.79c0,158.96,0,317.46,0,476.63c-23.62,0-46.07,0-69.04,0c0-342.36,0-684.11,0-1026.5c22.84,0,45,0,68.24,0
      c0.24,3.71,0.65,7.22,0.65,10.74c0.03,102.32,0.01,204.65,0.01,306.97c0,49.99-0.02,99.99,0,149.98c0,3.58,0.31,7.15,0.5,11.3
      c192.07,0,383.25,0,575.87,0c0.41-22.94,0.14-45.48,0.19-68.01c0.05-23,0.01-46,0.01-68.99c0-22.66,0-45.33,0-67.99
      s0-45.33,0-67.99s0-45.33,0-67.99c0-23,0-46,0-68.99c0-22.63,0-45.27,0-67.66c7.53-2.37,55.22-2.98,68.06-1.09
      c1.93,7.11,2.53,1012.91,0.44,1026.41c-22.22,1.03-44.63,0.3-68.26,0.47c0-159.43,0-317.87,0-477.28
      C1421.07,1532.79,1229.65,1532.79,1037.04,1532.79z"
          />
          <path
            d="M2351.24,983.05c138.72,342.1,277.12,683.43,415.53,1024.79c-7.64,2.83-48.31,3.65-75.77,1.78
      c-1.04-2.34-2.3-4.96-3.4-7.65c-27.33-66.95-54.62-133.92-81.95-200.87c-10.08-24.68-20.35-49.27-30.36-73.97
      c-7.25-17.91-14.41-35.86-21.21-53.94c-2.18-5.8-5.17-8.47-11.63-8.07c-8.63,0.53-17.33,0.13-25.99,0.13c-117.33,0-234.66,0-352,0
      c-2.67,0-5.35,0.2-8-0.03c-4.73-0.41-7.2,1.68-8.89,6.08c-5.02,13.06-10.45,25.97-15.7,38.95c-12.86,31.81-25.63,63.66-38.56,95.44
      c-26.5,65.13-53.09,130.22-79.65,195.33c-1.12,2.75-2.31,5.49-3.62,8.6c-24.99,0-49.82,0-74.69,0
      C1935.98,2001.8,2344.37,993.36,2351.24,983.05z M2351.6,1172.66c-0.83,0.08-1.65,0.16-2.48,0.24
      c-56.09,138.82-112.18,277.64-168.65,417.42c113.81,0,226.15,0,339.88,0C2463.81,1450.37,2407.71,1311.52,2351.6,1172.66z"
          />
          <path
            d="M3015.91,1881.04c13.23-18.09,25.76-35.21,38.63-52.8c4.4,3.73,8.15,6.96,11.95,10.12
      c55.51,46.16,119.34,74.98,189.52,90.14c55.47,11.98,111.47,15.69,167.89,7.66c41.72-5.94,81.17-18.52,116.52-42.13
      c71.19-47.56,93.27-123.54,78.96-195.14c-6.69-33.44-25.3-59.74-52.11-80.48c-26.4-20.43-56.29-34.22-87.2-46.03
      c-48.34-18.48-98.32-31.49-148.44-43.98c-52.77-13.16-104.8-28.62-154.18-51.83c-33.05-15.54-63.91-34.33-90.29-60.06
      c-34.27-33.42-53.64-74.19-60.79-121.05c-4.96-32.48-5.78-65.04,0.74-97.47c12.3-61.22,44.84-109.81,93.37-148.12
      c41.88-33.06,89.63-53.91,141.71-64.08c100.19-19.57,197.69-9.95,291.7,30.4c30.48,13.09,58.39,30.65,83.22,52.83
      c2.71,2.42,5.31,4.95,9,8.39c-13.14,17.49-26.01,34.61-39.33,52.33c-3.68-2.79-6.59-4.9-9.39-7.14
      c-52.6-42.07-112.78-66.29-179.07-76.08c-38.76-5.72-77.62-7.11-116.54-1.79c-48.65,6.65-94,22.15-133.74,51.7
      c-40.27,29.95-67.74,68.51-77.06,118.62c-4.87,26.2-4.28,52.43,1.54,78.43c8.54,38.18,31.27,66.35,62.96,88.05
      c23.8,16.3,49.77,28.32,76.54,38.72c46.98,18.25,95.47,31.66,144.14,44.45c54.84,14.41,109.07,30.63,160.76,54.35
      c28.89,13.25,56.33,28.94,80.71,49.53c40.61,34.31,63.76,77.97,69.29,130.86c4.17,39.84,2.15,79.24-9.56,117.76
      c-20.09,66.1-62.15,113.83-122.92,145.57c-40.1,20.94-83.17,32.29-127.89,37.27c-82.14,9.14-163.05,2.89-242.19-21.64
      c-54.02-16.74-103.72-41.9-147.34-78.32C3030.15,1894.33,3023.69,1888.07,3015.91,1881.04z"
          />
          <path
            d="M45.71,1880.49c12.78-17.44,25.16-34.34,37.93-51.77c1.6,0.99,3.05,1.64,4.19,2.64c54.44,48.07,117.93,78.38,188.16,94.98
      c58.23,13.76,117.15,18.23,176.65,9.89c44.14-6.19,85.61-19.8,122.4-45.8c82.12-58.04,88.06-150.42,69.32-207.25
      c-8.86-26.87-25.88-47.83-47.97-64.97c-22.85-17.73-48.49-30.43-75.15-41.22c-46.45-18.79-94.58-32.2-143.11-44.26
      c-50.49-12.54-100.64-26.11-148.77-46.19c-28.99-12.09-56.83-26.29-82.51-44.56c-56.15-39.95-86.63-94.32-93.16-162.78
      c-4.29-44.94-0.22-88.48,18.1-130.15c22.2-50.51,58.29-88.76,104.58-117.81c45.37-28.48,95.16-44.91,148.11-51.12
      c89.8-10.52,176.91-0.14,260.13,36.61c29.75,13.14,57.07,30.3,81.49,51.89c2.95,2.61,5.71,5.43,9.28,8.85
      c-13.09,17.46-25.8,34.42-38.94,51.95c-2.66-1.79-4.89-3.05-6.85-4.64c-57.86-47.03-124.56-72.23-198.18-80.4
      c-47.09-5.23-93.82-4.06-139.88,8.09c-46.64,12.31-88.47,33.38-122.17,68.66c-36.1,37.78-53.59,82.75-51.81,135.2
      c0.63,18.47,3.08,36.51,9.33,53.93c11.16,31.09,32.41,53.94,59.27,72.12c25.28,17.11,52.94,29.47,81.38,40.21
      c44.95,16.98,91.18,29.8,137.6,41.99c54.84,14.41,109.11,30.54,160.78,54.28c31.63,14.53,61.56,31.81,87.51,55.39
      c36.93,33.55,57.56,75.31,62.89,124.72c4.89,45.35,1.53,89.9-14.48,132.95c-21.95,59.01-62.24,101.68-117.6,130.62
      c-40.41,21.13-83.78,32.57-128.84,37.54c-81.81,9.03-162.4,2.82-241.21-21.6c-57.98-17.97-110.92-45.37-156.5-86.02
      c-3.23-2.88-6.32-5.92-9.44-8.93C47.53,1882.87,46.98,1882.03,45.71,1880.49z"
          />
          <path
            d="M4970.6,2009.63c-22.56,0-44.46,0-66.22,0c-0.36-0.38-0.6-0.61-0.82-0.86c-0.21-0.25-0.53-0.5-0.57-0.78
      c-0.21-1.64-0.49-3.3-0.49-4.95c0.01-337.33,0.04-674.66,0.1-1012c0-0.93,0.5-1.87,0.94-3.45c22.07,0,44.19,0,67.05,0
      C4970.6,1328.08,4970.6,1668.23,4970.6,2009.63z"
          />
        </g>
      </svg>
    </>
  );
};

const IconArrow = ({ rotate, className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      style={{ rotate: `${rotate}deg` }}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
    >
      <path
        d="M13.8751 1.49961C13.8728 1.33395 13.8088 1.17512 13.6954 1.0543C13.5769 0.936934 13.4169 0.871094 13.2501 0.871094C13.0833 0.871094 12.9233 0.936934 12.8048 1.0543L7.0001 6.8668L1.19541 1.0543C1.07398 0.954633 0.919811 0.9037 0.762903 0.911407C0.605996 0.919113 0.457564 0.984907 0.34648 1.09599C0.235396 1.20708 0.169602 1.35551 0.161895 1.51242C0.154189 1.66932 0.205121 1.82349 0.304786 1.94492L6.55479 8.19492C6.67328 8.31229 6.83332 8.37813 7.0001 8.37813C7.16688 8.37813 7.32691 8.31229 7.44541 8.19492L13.6954 1.94492C13.8088 1.8241 13.8728 1.66526 13.8751 1.49961Z"
        fill="black"
      />
    </svg>
  );
};

const IconCarouselLeftArrow = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_5004_8024)">
        <path
          d="M17.3043 -6.67572e-05C17.6592 -6.67572e-05 18.0156 0.13512 18.2875 0.407696C18.8306 0.950775 18.8306 1.82962 18.2875 2.3727L8.6597 11.9999L18.2875 21.6277C18.8306 22.1708 18.8306 23.0504 18.2875 23.5927C17.7444 24.1358 16.8648 24.1358 16.3219 23.5927L5.71226 12.9831C5.16918 12.44 5.16918 11.5604 5.71226 11.0181L16.3219 0.407825C16.5929 0.135899 16.9486 -6.67572e-05 17.3043 -6.67572e-05Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5004_8024">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="matrix(-1 0 0 -1 24 24)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const IconCarouselRightArrow = ({ className }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4979_3058)">
        <path
          d="M6.6957 24.0001C6.34077 24.0001 5.98441 23.8649 5.71249 23.5923C5.16941 23.0492 5.16941 22.1704 5.71249 21.6273L15.3403 12.0001L5.71249 2.37232C5.16941 1.82924 5.16941 0.949612 5.71249 0.40731C6.25556 -0.13577 7.13519 -0.13577 7.67814 0.40731L18.2877 11.0169C18.8308 11.56 18.8308 12.4396 18.2877 12.9819L7.67814 23.5922C7.40712 23.8641 7.05141 24.0001 6.6957 24.0001Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4979_3058">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const IconTick = (props) => {
  return (
    <SvgIcon
      sx={{
        marginLeft: "auto",
        marginRight: "auto",
        fontSize: "15px",
        color: "white.main",
      }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 10"
      fill="none"
    >
      <path d="M4 9.4L0 5.4L1.4 4L4 6.6L10.6 0L12 1.4L4 9.4Z" />
    </SvgIcon>
  );
};

const FailureIcon = () => {
  return (
    <svg
      width="110"
      height="110"
      viewBox="0 0 110 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="55" cy="55" r="53" stroke="#FF003D" stroke-width="4" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M68.9735 42.0272C69.7871 42.8408 69.7871 44.1599 68.9735 44.9735L43.9735 69.9735C43.1599 70.7871 41.8408 70.7871 41.0272 69.9735C40.2136 69.1599 40.2136 67.8408 41.0272 67.0272L66.0272 42.0272C66.8408 41.2136 68.1599 41.2136 68.9735 42.0272Z"
        fill="#FF003E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M41.0272 42.0272C41.8408 41.2136 43.1599 41.2136 43.9735 42.0272L68.9735 67.0272C69.7871 67.8408 69.7871 69.1599 68.9735 69.9735C68.1599 70.7871 66.8408 70.7871 66.0272 69.9735L41.0272 44.9735C40.2136 44.1599 40.2136 42.8408 41.0272 42.0272Z"
        fill="#FF003E"
      />
    </svg>
  );
};

const InfoIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0C8.93293 0 10.6829 0.783672 11.9498 2.05023C13.2163 3.3168 14 5.06707 14 7C14 8.93293 13.2163 10.6832 11.9498 11.9498C10.6829 13.2163 8.93293 14 7 14C5.06707 14 3.31707 13.2163 2.05023 11.9498C0.783672 10.6829 0 8.93293 0 7C0 5.06707 0.783672 3.31707 2.05023 2.05023C3.31707 0.783672 5.06707 0 7 0ZM6.72766 4.40316C6.72766 4.28613 6.74844 4.1773 6.78973 4.0775C6.83074 3.97824 6.89281 3.88773 6.97539 3.80652C7.05742 3.72586 7.14738 3.66434 7.24445 3.62332C7.34207 3.5823 7.44707 3.56098 7.55945 3.56098C7.67211 3.56098 7.77711 3.5823 7.87363 3.62305C7.97043 3.66434 8.05902 3.72586 8.14023 3.80707C8.2209 3.88828 8.28133 3.97824 8.3218 4.07805C8.36254 4.1773 8.3825 4.28613 8.3825 4.40316C8.3825 4.51719 8.36254 4.6241 8.32207 4.72281C8.2816 4.82125 8.22145 4.91258 8.14023 4.99543C8.05984 5.07828 7.97125 5.1409 7.87445 5.18246C7.77766 5.22375 7.67266 5.24508 7.55945 5.24508C7.44406 5.24508 7.33687 5.2243 7.23816 5.18328C7.14027 5.14199 7.05059 5.07965 6.96938 4.99762C6.88898 4.91504 6.82828 4.82426 6.78809 4.725C6.74762 4.62602 6.72766 4.51883 6.72766 4.40316ZM7.09406 9.27473C7.06371 9.38328 7.00246 9.59629 7.1843 9.59629C7.22367 9.59629 7.27371 9.57414 7.33359 9.53066C7.3984 9.48391 7.47277 9.41281 7.5559 9.31875C7.64039 9.22305 7.72871 9.10957 7.82031 8.97914C7.91137 8.84898 8.00734 8.69969 8.10715 8.53316C8.11727 8.51539 8.14078 8.50937 8.15883 8.52004L8.4968 8.77105C8.5132 8.78281 8.51676 8.80523 8.50637 8.82191C8.35078 9.09207 8.19355 9.32805 8.03441 9.52957C7.87445 9.73219 7.71203 9.90063 7.5477 10.0335L7.54496 10.0352C7.38035 10.1686 7.21164 10.2689 7.03883 10.3362C6.55813 10.5224 5.79852 10.4921 5.58086 9.9307C5.44359 9.57633 5.55625 9.17355 5.66453 8.82684L6.21031 7.17418C6.24531 7.04894 6.28934 6.91113 6.3052 6.78234C6.33172 6.56715 6.23711 6.42797 6.00277 6.42797H5.52563C5.50484 6.42797 5.48789 6.41102 5.48789 6.39023L5.49008 6.37711L5.61531 5.92102C5.61969 5.90406 5.63527 5.89258 5.65223 5.89313L8.0891 5.81684C8.10988 5.81602 8.12766 5.83242 8.12848 5.8532L8.12656 5.86496L7.09406 9.27473ZM11.4226 2.57742C10.2908 1.44566 8.72703 0.745391 7 0.745391C5.27297 0.745391 3.70918 1.44566 2.57742 2.57742C1.44566 3.70918 0.745391 5.27297 0.745391 7C0.745391 8.72703 1.44566 10.2908 2.57742 11.4226C3.70918 12.5543 5.27297 13.2546 7 13.2546C8.72703 13.2546 10.2908 12.5543 11.4226 11.4226C12.5543 10.2908 13.2546 8.72703 13.2546 7C13.2546 5.27297 12.5543 3.70918 11.4226 2.57742Z"
        fill="black"
      />
    </svg>
  );
};

const AppStoreIcon = () => {
  return (
    <>
      {/*?xml version="1.0" encoding="utf-8"?*/}
      {/* Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools */}
      <svg
        width="120px"
        height="120px"
        viewBox="0 -189.93 539.856 539.856"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="scale(4.00216 4.0011)">
          <path
            fill="#FFF"
            d="M134.032 35.268a3.83 3.83 0 0 1-3.834 3.83H4.729a3.835 3.835 0 0 1-3.839-3.83V4.725A3.84 3.84 0 0 1 4.729.89h125.468a3.834 3.834 0 0 1 3.834 3.835l.001 30.543z"
          />
          <path
            fill="#A6A6A6"
            d="M130.198 39.989H4.729A4.73 4.73 0 0 1 0 35.268V4.726A4.733 4.733 0 0 1 4.729 0h125.468a4.735 4.735 0 0 1 4.729 4.726v30.542c.002 2.604-2.123 4.721-4.728 4.721z"
          />
          <path d="M134.032 35.268a3.83 3.83 0 0 1-3.834 3.83H4.729a3.835 3.835 0 0 1-3.839-3.83V4.725A3.84 3.84 0 0 1 4.729.89h125.468a3.834 3.834 0 0 1 3.834 3.835l.001 30.543z" />
          <path
            fill="#FFF"
            d="M30.128 19.784c-.029-3.223 2.639-4.791 2.761-4.864-1.511-2.203-3.853-2.504-4.676-2.528-1.967-.207-3.875 1.177-4.877 1.177-1.022 0-2.565-1.157-4.228-1.123-2.14.033-4.142 1.272-5.24 3.196-2.266 3.923-.576 9.688 1.595 12.859 1.086 1.554 2.355 3.287 4.016 3.226 1.625-.066 2.232-1.035 4.193-1.035 1.943 0 2.513 1.035 4.207.996 1.744-.027 2.842-1.56 3.89-3.127 1.255-1.779 1.759-3.533 1.779-3.623-.04-.014-3.386-1.292-3.42-5.154zM26.928 10.306c.874-1.093 1.472-2.58 1.306-4.089-1.265.056-2.847.875-3.758 1.944-.806.942-1.526 2.486-1.34 3.938 1.421.106 2.88-.717 3.792-1.793z"
          />
          <linearGradient
            id="a"
            gradientUnits="userSpaceOnUse"
            x1="-23.235"
            y1="97.431"
            x2="-23.235"
            y2="61.386"
            gradientTransform="matrix(4.0022 0 0 4.0011 191.95 -349.736)"
          >
            <stop offset={0} stopColor="#1a1a1a" stopOpacity=".1" />
            <stop offset=".123" stopColor="#212121" stopOpacity=".151" />
            <stop offset=".308" stopColor="#353535" stopOpacity=".227" />
            <stop offset=".532" stopColor="#575757" stopOpacity=".318" />
            <stop offset=".783" stopColor="#858585" stopOpacity=".421" />
            <stop offset={1} stopColor="#b3b3b3" stopOpacity=".51" />
          </linearGradient>
          <path
            fill="url(#a)"
            d="M130.198 0H62.993l26.323 39.989h40.882a4.733 4.733 0 0 0 4.729-4.724V4.726A4.734 4.734 0 0 0 130.198 0z"
          />
          <g fill="#FFF">
            <path d="M53.665 31.504h-2.271l-1.244-3.909h-4.324l-1.185 3.909H42.43l4.285-13.308h2.646l4.304 13.308zm-3.89-5.549L48.65 22.48c-.119-.355-.343-1.191-.671-2.507h-.04c-.132.566-.343 1.402-.632 2.507l-1.106 3.475h3.574zM64.663 26.588c0 1.632-.443 2.922-1.33 3.869-.794.843-1.781 1.264-2.958 1.264-1.271 0-2.185-.453-2.74-1.361v5.035h-2.132V25.062c0-1.025-.027-2.076-.079-3.154h1.875l.119 1.521h.04c.711-1.146 1.79-1.719 3.238-1.719 1.132 0 2.077.447 2.833 1.342.755.897 1.134 2.075 1.134 3.536zm-2.172.078c0-.934-.21-1.704-.632-2.311-.461-.631-1.08-.947-1.856-.947-.526 0-1.004.176-1.431.523-.428.35-.708.807-.839 1.373a2.784 2.784 0 0 0-.099.649v1.601c0 .697.214 1.286.642 1.768.428.48.984.721 1.668.721.803 0 1.428-.311 1.875-.928.448-.619.672-1.435.672-2.449zM75.7 26.588c0 1.632-.443 2.922-1.33 3.869-.795.843-1.781 1.264-2.959 1.264-1.271 0-2.185-.453-2.74-1.361v5.035h-2.132V25.062c0-1.025-.027-2.076-.079-3.154h1.875l.119 1.521h.04c.71-1.146 1.789-1.719 3.238-1.719 1.131 0 2.076.447 2.834 1.342.754.897 1.134 2.075 1.134 3.536zm-2.173.078c0-.934-.211-1.704-.633-2.311-.461-.631-1.078-.947-1.854-.947-.526 0-1.004.176-1.433.523-.428.35-.707.807-.838 1.373-.065.264-.1.479-.1.649v1.601c0 .697.215 1.286.641 1.768.428.479.984.721 1.67.721.804 0 1.429-.311 1.875-.928.448-.619.672-1.435.672-2.449zM88.04 27.771c0 1.133-.396 2.054-1.183 2.765-.866.776-2.075 1.165-3.625 1.165-1.432 0-2.58-.276-3.446-.829l.493-1.777c.935.554 1.962.83 3.08.83.804 0 1.429-.182 1.875-.543.447-.362.673-.846.673-1.45 0-.541-.187-.994-.554-1.363-.369-.368-.979-.711-1.836-1.026-2.33-.869-3.496-2.14-3.496-3.812 0-1.092.412-1.986 1.234-2.685.822-.698 1.912-1.047 3.268-1.047 1.211 0 2.22.211 3.021.632l-.535 1.738c-.754-.408-1.605-.612-2.557-.612-.752 0-1.342.185-1.764.553-.355.329-.535.73-.535 1.206 0 .525.205.961.613 1.303.354.315 1 .658 1.934 1.026 1.146.462 1.988 1 2.527 1.618.543.618.813 1.389.813 2.308zM95.107 23.508h-2.35v4.659c0 1.185.414 1.776 1.244 1.776.381 0 .697-.032.947-.099l.059 1.619c-.42.157-.973.236-1.658.236-.842 0-1.5-.257-1.975-.771-.473-.514-.711-1.375-.711-2.587v-4.837h-1.4v-1.6h1.4v-1.757l2.094-.632v2.389h2.35v1.604zM105.689 26.627c0 1.475-.422 2.686-1.264 3.633-.881.975-2.053 1.461-3.514 1.461-1.41 0-2.531-.467-3.367-1.4-.836-.935-1.254-2.113-1.254-3.534 0-1.487.432-2.705 1.293-3.652.863-.948 2.025-1.422 3.486-1.422 1.408 0 2.539.468 3.395 1.402.818.906 1.225 2.076 1.225 3.512zm-2.21.049c0-.879-.19-1.633-.571-2.264-.447-.762-1.087-1.143-1.916-1.143-.854 0-1.509.381-1.955 1.143-.382.631-.572 1.398-.572 2.304 0 .88.19 1.636.572 2.265.461.762 1.104 1.143 1.937 1.143.815 0 1.454-.389 1.916-1.162.392-.646.589-1.405.589-2.286zM112.622 23.783a3.71 3.71 0 0 0-.672-.059c-.75 0-1.33.282-1.738.85-.354.5-.532 1.132-.532 1.895v5.035h-2.132V24.93a67.43 67.43 0 0 0-.062-3.021h1.857l.078 1.836h.059c.226-.631.58-1.14 1.066-1.521a2.578 2.578 0 0 1 1.541-.514c.197 0 .375.014.533.039l.002 2.034zM122.157 26.252a5 5 0 0 1-.078.967h-6.396c.024.948.334 1.674.928 2.174.539.446 1.236.67 2.092.67.947 0 1.811-.15 2.588-.453l.334 1.479c-.908.396-1.98.593-3.217.593-1.488 0-2.656-.438-3.506-1.312-.848-.875-1.273-2.051-1.273-3.524 0-1.446.395-2.651 1.186-3.612.828-1.026 1.947-1.539 3.355-1.539 1.383 0 2.43.513 3.141 1.539.563.813.846 1.821.846 3.018zm-2.033-.553c.015-.633-.125-1.178-.414-1.639-.369-.594-.937-.89-1.698-.89-.697 0-1.265.289-1.697.869-.355.461-.566 1.015-.631 1.658l4.44.002z" />
          </g>
          <g fill="#FFF">
            <path d="M45.211 13.491c-.593 0-1.106-.029-1.533-.078V6.979a11.606 11.606 0 0 1 1.805-.136c2.445 0 3.571 1.203 3.571 3.164 0 2.262-1.33 3.484-3.843 3.484zm.358-5.823c-.33 0-.611.02-.844.068v4.891c.126.02.368.029.708.029 1.602 0 2.514-.912 2.514-2.62 0-1.523-.825-2.368-2.378-2.368zM52.563 13.54c-1.378 0-2.271-1.029-2.271-2.426 0-1.456.912-2.494 2.349-2.494 1.358 0 2.271.98 2.271 2.417 0 1.474-.941 2.503-2.349 2.503zm.04-4.154c-.757 0-1.242.708-1.242 1.698 0 .971.495 1.679 1.232 1.679s1.232-.757 1.232-1.699c0-.96-.485-1.678-1.222-1.678zM62.77 8.717l-1.475 4.716h-.961l-.611-2.048a15.53 15.53 0 0 1-.379-1.523h-.02c-.077.514-.223 1.029-.378 1.523l-.65 2.048h-.971l-1.388-4.716h1.077l.534 2.242c.126.534.232 1.038.32 1.514h.02c.077-.397.203-.893.388-1.504l.67-2.251h.854l.641 2.203c.155.534.281 1.058.379 1.553h.028c.068-.485.175-1 .32-1.553l.573-2.203 1.029-.001zM68.2 13.433h-1.048v-2.708c0-.834-.32-1.252-.951-1.252-.621 0-1.048.534-1.048 1.155v2.805h-1.048v-3.368c0-.417-.01-.864-.039-1.349h.922l.049.728h.029c.282-.504.854-.824 1.495-.824.99 0 1.64.757 1.64 1.989l-.001 2.824zM71.09 13.433h-1.049v-6.88h1.049v6.88zM74.911 13.54c-1.377 0-2.271-1.029-2.271-2.426 0-1.456.912-2.494 2.348-2.494 1.359 0 2.271.98 2.271 2.417.001 1.474-.941 2.503-2.348 2.503zm.039-4.154c-.757 0-1.242.708-1.242 1.698 0 .971.496 1.679 1.231 1.679.738 0 1.232-.757 1.232-1.699.001-.96-.483-1.678-1.221-1.678zM81.391 13.433l-.076-.543h-.028c-.32.437-.787.65-1.379.65-.845 0-1.445-.592-1.445-1.388 0-1.164 1.009-1.766 2.756-1.766v-.087c0-.621-.329-.932-.979-.932-.465 0-.873.117-1.232.35l-.213-.689c.436-.272.98-.408 1.619-.408 1.232 0 1.854.65 1.854 1.951v1.737c0 .476.021.845.068 1.126l-.945-.001zm-.144-2.349c-1.164 0-1.748.282-1.748.951 0 .495.301.737.719.737.533 0 1.029-.407 1.029-.96v-.728zM87.357 13.433l-.049-.757h-.029c-.301.572-.807.864-1.514.864-1.137 0-1.979-1-1.979-2.407 0-1.475.873-2.514 2.065-2.514.631 0 1.078.213 1.33.641h.021V6.553h1.049v5.609c0 .456.011.883.039 1.271h-.933zm-.155-2.775c0-.66-.437-1.223-1.104-1.223-.777 0-1.252.689-1.252 1.659 0 .951.493 1.602 1.231 1.602.659 0 1.125-.573 1.125-1.252v-.786zM94.902 13.54c-1.377 0-2.27-1.029-2.27-2.426 0-1.456.912-2.494 2.348-2.494 1.359 0 2.271.98 2.271 2.417.001 1.474-.94 2.503-2.349 2.503zm.039-4.154c-.756 0-1.241.708-1.241 1.698 0 .971.495 1.679 1.231 1.679.738 0 1.232-.757 1.232-1.699.002-.96-.483-1.678-1.222-1.678zM102.887 13.433h-1.049v-2.708c0-.834-.32-1.252-.951-1.252-.621 0-1.047.534-1.047 1.155v2.805h-1.049v-3.368c0-.417-.01-.864-.039-1.349h.922l.049.728h.029c.281-.504.854-.825 1.494-.825.99 0 1.641.757 1.641 1.989v2.825zM109.938 9.503h-1.153v2.29c0 .583.202.874.61.874.185 0 .34-.02.465-.049l.029.796c-.203.078-.475.117-.813.117-.826 0-1.32-.456-1.32-1.65V9.503h-.688v-.786h.688v-.864l1.029-.311v1.174h1.153v.787zM115.486 13.433h-1.047v-2.688c0-.844-.319-1.271-.951-1.271-.543 0-1.049.369-1.049 1.116v2.843h-1.047v-6.88h1.047v2.833h.021c.33-.514.808-.767 1.418-.767.998 0 1.608.776 1.608 2.009v2.805zM121.17 11.327h-3.145c.02.893.611 1.397 1.486 1.397.465 0 .893-.078 1.271-.223l.163.728c-.446.194-.971.291-1.582.291-1.475 0-2.348-.932-2.348-2.377 0-1.446.894-2.533 2.23-2.533 1.205 0 1.961.893 1.961 2.242a2.02 2.02 0 0 1-.036.475zm-.961-.747c0-.728-.367-1.242-1.037-1.242-.602 0-1.078.524-1.146 1.242h2.183z" />
          </g>
        </g>
      </svg>
    </>
  );
};

const GooglePayIcon = () => {
  return (
    <>
      {/*?xml version="1.0" encoding="utf-8"?*/}
      {/* Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools */}
      <svg
        width="120px"
        height="120px"
        viewBox="0 -47.5 135 135"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <style
          dangerouslySetInnerHTML={{
            __html:
              ".st0{fill:#a6a6a6}.st1{stroke:#ffffff;stroke-width:.2;stroke-miterlimit:10}.st1,.st2{fill:#fff}.st3{fill:url(#SVGID_1_)}.st4{fill:url(#SVGID_2_)}.st5{fill:url(#SVGID_3_)}.st6{fill:url(#SVGID_4_)}.st7,.st8,.st9{opacity:.2;enable-background:new}.st8,.st9{opacity:.12}.st9{opacity:.25;fill:#fff}",
          }}
        />
        <path d="M130 40H5c-2.8 0-5-2.2-5-5V5c0-2.8 2.2-5 5-5h125c2.8 0 5 2.2 5 5v30c0 2.8-2.2 5-5 5z" />
        <path
          className="st0"
          d="M130 .8c2.3 0 4.2 1.9 4.2 4.2v30c0 2.3-1.9 4.2-4.2 4.2H5C2.7 39.2.8 37.3.8 35V5C.8 2.7 2.7.8 5 .8h125m0-.8H5C2.2 0 0 2.3 0 5v30c0 2.8 2.2 5 5 5h125c2.8 0 5-2.2 5-5V5c0-2.7-2.2-5-5-5z"
        />
        <path
          className="st1"
          d="M47.4 10.2c0 .8-.2 1.5-.7 2-.6.6-1.3.9-2.2.9-.9 0-1.6-.3-2.2-.9-.6-.6-.9-1.3-.9-2.2 0-.9.3-1.6.9-2.2.6-.6 1.3-.9 2.2-.9.4 0 .8.1 1.2.3.4.2.7.4.9.7l-.5.5c-.4-.5-.9-.7-1.6-.7-.6 0-1.2.2-1.6.7-.5.4-.7 1-.7 1.7s.2 1.3.7 1.7c.5.4 1 .7 1.6.7.7 0 1.2-.2 1.7-.7.3-.3.5-.7.5-1.2h-2.2v-.8h2.9v.4zM52 7.7h-2.7v1.9h2.5v.7h-2.5v1.9H52v.8h-3.5V7H52v.7zM55.3 13h-.8V7.7h-1.7V7H57v.7h-1.7V13zM59.9 13V7h.8v6h-.8zM64.1 13h-.8V7.7h-1.7V7h4.1v.7H64V13zM73.6 12.2c-.6.6-1.3.9-2.2.9-.9 0-1.6-.3-2.2-.9-.6-.6-.9-1.3-.9-2.2s.3-1.6.9-2.2c.6-.6 1.3-.9 2.2-.9.9 0 1.6.3 2.2.9.6.6.9 1.3.9 2.2 0 .9-.3 1.6-.9 2.2zm-3.8-.5c.4.4 1 .7 1.6.7.6 0 1.2-.2 1.6-.7.4-.4.7-1 .7-1.7s-.2-1.3-.7-1.7c-.4-.4-1-.7-1.6-.7-.6 0-1.2.2-1.6.7-.4.4-.7 1-.7 1.7s.2 1.3.7 1.7zM75.6 13V7h.9l2.9 4.7V7h.8v6h-.8l-3.1-4.9V13h-.7z"
        />
        <path
          className="st2"
          d="M68.1 21.8c-2.4 0-4.3 1.8-4.3 4.3 0 2.4 1.9 4.3 4.3 4.3s4.3-1.8 4.3-4.3c0-2.6-1.9-4.3-4.3-4.3zm0 6.8c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6c1.3 0 2.4 1 2.4 2.6 0 1.5-1.1 2.6-2.4 2.6zm-9.3-6.8c-2.4 0-4.3 1.8-4.3 4.3 0 2.4 1.9 4.3 4.3 4.3s4.3-1.8 4.3-4.3c0-2.6-1.9-4.3-4.3-4.3zm0 6.8c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6c1.3 0 2.4 1 2.4 2.6 0 1.5-1.1 2.6-2.4 2.6zm-11.1-5.5v1.8H52c-.1 1-.5 1.8-1 2.3-.6.6-1.6 1.3-3.3 1.3-2.7 0-4.7-2.1-4.7-4.8s2.1-4.8 4.7-4.8c1.4 0 2.5.6 3.3 1.3l1.3-1.3c-1.1-1-2.5-1.8-4.5-1.8-3.6 0-6.7 3-6.7 6.6 0 3.6 3.1 6.6 6.7 6.6 2 0 3.4-.6 4.6-1.9 1.2-1.2 1.6-2.9 1.6-4.2 0-.4 0-.8-.1-1.1h-6.2zm45.4 1.4c-.4-1-1.4-2.7-3.6-2.7s-4 1.7-4 4.3c0 2.4 1.8 4.3 4.2 4.3 1.9 0 3.1-1.2 3.5-1.9l-1.4-1c-.5.7-1.1 1.2-2.1 1.2s-1.6-.4-2.1-1.3l5.7-2.4-.2-.5zm-5.8 1.4c0-1.6 1.3-2.5 2.2-2.5.7 0 1.4.4 1.6.9l-3.8 1.6zM82.6 30h1.9V17.5h-1.9V30zm-3-7.3c-.5-.5-1.3-1-2.3-1-2.1 0-4.1 1.9-4.1 4.3s1.9 4.2 4.1 4.2c1 0 1.8-.5 2.2-1h.1v.6c0 1.6-.9 2.5-2.3 2.5-1.1 0-1.9-.8-2.1-1.5l-1.6.7c.5 1.1 1.7 2.5 3.8 2.5 2.2 0 4-1.3 4-4.4V22h-1.8v.7zm-2.2 5.9c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6c1.3 0 2.3 1.1 2.3 2.6s-1 2.6-2.3 2.6zm24.4-11.1h-4.5V30h1.9v-4.7h2.6c2.1 0 4.1-1.5 4.1-3.9s-2-3.9-4.1-3.9zm.1 6h-2.7v-4.3h2.7c1.4 0 2.2 1.2 2.2 2.1-.1 1.1-.9 2.2-2.2 2.2zm11.5-1.8c-1.4 0-2.8.6-3.3 1.9l1.7.7c.4-.7 1-.9 1.7-.9 1 0 1.9.6 2 1.6v.1c-.3-.2-1.1-.5-1.9-.5-1.8 0-3.6 1-3.6 2.8 0 1.7 1.5 2.8 3.1 2.8 1.3 0 1.9-.6 2.4-1.2h.1v1h1.8v-4.8c-.2-2.2-1.9-3.5-4-3.5zm-.2 6.9c-.6 0-1.5-.3-1.5-1.1 0-1 1.1-1.3 2-1.3.8 0 1.2.2 1.7.4-.2 1.2-1.2 2-2.2 2zm10.5-6.6l-2.1 5.4h-.1l-2.2-5.4h-2l3.3 7.6-1.9 4.2h1.9l5.1-11.8h-2zm-16.8 8h1.9V17.5h-1.9V30z"
        />
        <g>
          <linearGradient
            id="SVGID_1_"
            gradientUnits="userSpaceOnUse"
            x1="21.8"
            y1="33.29"
            x2="5.017"
            y2="16.508"
            gradientTransform="matrix(1 0 0 -1 0 42)"
          >
            <stop offset={0} stopColor="#00a0ff" />
            <stop offset=".007" stopColor="#00a1ff" />
            <stop offset=".26" stopColor="#00beff" />
            <stop offset=".512" stopColor="#00d2ff" />
            <stop offset=".76" stopColor="#00dfff" />
            <stop offset={1} stopColor="#00e3ff" />
          </linearGradient>
          <path
            className="st3"
            d="M10.4 7.5c-.3.3-.4.8-.4 1.4V31c0 .6.2 1.1.5 1.4l.1.1L23 20.1v-.2L10.4 7.5z"
          />
          <linearGradient
            id="SVGID_2_"
            gradientUnits="userSpaceOnUse"
            x1="33.834"
            y1="21.999"
            x2="9.637"
            y2="21.999"
            gradientTransform="matrix(1 0 0 -1 0 42)"
          >
            <stop offset={0} stopColor="#ffe000" />
            <stop offset=".409" stopColor="#ffbd00" />
            <stop offset=".775" stopColor="orange" />
            <stop offset={1} stopColor="#ff9c00" />
          </linearGradient>
          <path
            className="st4"
            d="M27 24.3l-4.1-4.1V19.9l4.1-4.1.1.1 4.9 2.8c1.4.8 1.4 2.1 0 2.9l-5 2.7z"
          />
          <linearGradient
            id="SVGID_3_"
            gradientUnits="userSpaceOnUse"
            x1="24.827"
            y1="19.704"
            x2="2.069"
            y2="-3.054"
            gradientTransform="matrix(1 0 0 -1 0 42)"
          >
            <stop offset={0} stopColor="#ff3a44" />
            <stop offset={1} stopColor="#c31162" />
          </linearGradient>
          <path
            className="st5"
            d="M27.1 24.2L22.9 20 10.4 32.5c.5.5 1.2.5 2.1.1l14.6-8.4"
          />
          <linearGradient
            id="SVGID_4_"
            gradientUnits="userSpaceOnUse"
            x1="7.297"
            y1="41.824"
            x2="17.46"
            y2="31.661"
            gradientTransform="matrix(1 0 0 -1 0 42)"
          >
            <stop offset={0} stopColor="#32a071" />
            <stop offset=".069" stopColor="#2da771" />
            <stop offset=".476" stopColor="#15cf74" />
            <stop offset=".801" stopColor="#06e775" />
            <stop offset={1} stopColor="#00f076" />
          </linearGradient>
          <path
            className="st6"
            d="M27.1 15.8L12.5 7.5c-.9-.5-1.6-.4-2.1.1L22.9 20l4.2-4.2z"
          />
          <path
            className="st7"
            d="M27 24.1l-14.5 8.2c-.8.5-1.5.4-2 0l-.1.1.1.1c.5.4 1.2.5 2 0L27 24.1z"
          />
          <path
            className="st8"
            d="M10.4 32.3c-.3-.3-.4-.8-.4-1.4v.1c0 .6.2 1.1.5 1.4v-.1h-.1zM32 21.3l-5 2.8.1.1 4.9-2.8c.7-.4 1-.9 1-1.4 0 .5-.4.9-1 1.3z"
          />
          <path
            className="st9"
            d="M12.5 7.6L32 18.7c.6.4 1 .8 1 1.3 0-.5-.3-1-1-1.4L12.5 7.5c-1.4-.8-2.5-.2-2.5 1.4V9c0-1.5 1.1-2.2 2.5-1.4z"
          />
        </g>
      </svg>
    </>
  );
};

const ReservationCancelFailedIcon = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 110 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="55" cy="55" r="53" stroke="#FF003D" stroke-width="4" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M68.9735 42.0272C69.7871 42.8408 69.7871 44.1599 68.9735 44.9735L43.9735 69.9735C43.1599 70.7871 41.8408 70.7871 41.0272 69.9735C40.2136 69.1599 40.2136 67.8408 41.0272 67.0272L66.0272 42.0272C66.8408 41.2136 68.1599 41.2136 68.9735 42.0272Z"
        fill="#FF003E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M41.0272 42.0272C41.8408 41.2136 43.1599 41.2136 43.9735 42.0272L68.9735 67.0272C69.7871 67.8408 69.7871 69.1599 68.9735 69.9735C68.1599 70.7871 66.8408 70.7871 66.0272 69.9735L41.0272 44.9735C40.2136 44.1599 40.2136 42.8408 41.0272 42.0272Z"
        fill="#FF003E"
      />
    </svg>
  );
};
const ReservationCancelSuccessfulIcon = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 112 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.6667 55.9994L48.185 68.1658C50.4864 70.237 54.0619 69.9199 55.9627 67.4759L77.3334 39.9994M56.0001 109.333C85.4553 109.333 109.333 85.4545 109.333 55.9994C109.333 26.5442 85.4553 2.66602 56.0001 2.66602C26.5449 2.66602 2.66675 26.5442 2.66675 55.9994C2.66675 85.4545 26.5449 109.333 56.0001 109.333Z"
        stroke="#FE0097"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const IconEnrollDropdownArrow = ({collapse}) => {
  return <svg style={{rotate:collapse?'180deg':'360deg',transitionDuration:'1s'}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M2.49953 6.00281C2.50133 5.87029 2.5526 5.74322 2.64328 5.64656C2.73808 5.55267 2.86611 5.5 2.99953 5.5C3.13295 5.5 3.26098 5.55267 3.35578 5.64656L7.99953 10.2966L12.6433 5.64656C12.7404 5.56683 12.8638 5.52609 12.9893 5.53225C13.1148 5.53842 13.2336 5.59105 13.3224 5.67992C13.4113 5.76879 13.4639 5.88753 13.4701 6.01306C13.4763 6.13858 13.4355 6.26191 13.3558 6.35906L8.35578 11.3591C8.26098 11.453 8.13295 11.5056 7.99953 11.5056C7.86611 11.5056 7.73808 11.453 7.64328 11.3591L2.64328 6.35906C2.5526 6.2624 2.50133 6.13534 2.49953 6.00281Z" fill="#ab0067"/>
  </svg>
}
const ArrowLogo = ({onClick=()=>{}}) => {
return <svg onClick={onClick} className="cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
<path d="M22.5 12.5L15.8839 19.1161C15.3957 19.6043 14.6043 19.6043 14.1161 19.1161L7.5 12.5" stroke="black" stroke-width="2" stroke-linecap="round"/>
</svg>
}

const Indicator = ({ child = "ddsdfdsfdsd" }) => {
  return (
    <div className="relative indicator-logo min-w-20 h-[30px] bg-black text-white flex items-center justify-center text-[10px] px-[9px] ">
      <svg
        className="absolute left-0 ml-[-5px]"
        width="6"
        height="13"
        viewBox="0 0 6 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 6.5L6 0.870834L6 12.1292L0 6.5Z" fill="black" />
      </svg>
      {child}
    </div>
  );
};

const Circle = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M8 1.75C6.3424 1.75 4.75269 2.40848 3.58058 3.58058C2.40848 4.75269 1.75 6.3424 1.75 8C1.75 9.6576 2.40848 11.2473 3.58058 12.4194C4.75269 13.5915 6.3424 14.25 8 14.25C9.6576 14.25 11.2473 13.5915 12.4194 12.4194C13.5915 11.2473 14.25 9.6576 14.25 8C14.25 6.3424 13.5915 4.75269 12.4194 3.58058C11.2473 2.40848 9.6576 1.75 8 1.75ZM0.5 8C0.5 7.01509 0.693993 6.03982 1.0709 5.12987C1.44781 4.21993 2.00026 3.39314 2.6967 2.6967C3.39314 2.00026 4.21993 1.44781 5.12987 1.0709C6.03982 0.693993 7.01509 0.5 8 0.5C8.98491 0.5 9.96018 0.693993 10.8701 1.0709C11.7801 1.44781 12.6069 2.00026 13.3033 2.6967C13.9997 3.39314 14.5522 4.21993 14.9291 5.12987C15.306 6.03982 15.5 7.01509 15.5 8C15.5 9.98912 14.7098 11.8968 13.3033 13.3033C11.8968 14.7098 9.98912 15.5 8 15.5C6.01088 15.5 4.10322 14.7098 2.6967 13.3033C1.29018 11.8968 0.5 9.98912 0.5 8Z" fill="black" />
    </svg>
  )
}

const TickCircle = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="8" fill="#F41095" />
      <path d="M6.5939 10.9991L3.94922 8.37313L4.87486 7.45405L6.5939 9.16091L10.9576 4.82812L11.8833 5.7472L6.5939 10.9991Z" fill="white" />
    </svg>
  )
}

export {
  IconLogo,
  IconArrow,
  IconTick,
  FailureIcon,
  InfoIcon,
  IconEnrollDropdownArrow,
  ReservationCancelSuccessfulIcon,
  ReservationCancelFailedIcon,
  IconCarouselLeftArrow,
  IconCarouselRightArrow,
  AppStoreIcon,
  GooglePayIcon,
  ArrowLogo,
  Indicator,
  Circle,
  TickCircle
};
